import Transfer from '@/page/transfer';

export default [
    {
        path: '/transfer',
        name: 'Tranfser',
        component: Transfer,
        meta: {
            title: '',
            keepAlive: false
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/transfer.route.js